/**
 * 统一批量上传弹窗控制器
 */
import Vue from 'vue';
import batchUpload from './material-batch-upload-dialog';
import store from '@/store/index.js';
import {Message} from '@com.thunisoft.9law/element-ui';
const DialogConstructor = Vue.extend(batchUpload);
const instance = new DialogConstructor({el: document.createElement('div'), store});
const newLoading = {
  show(op) {
    let $task = document.getElementById('com-task');
    if ($task && !['4', '6', '7'].includes($task.dataset.status)) {
      return Message.error('当前已存在其他任务，请稍后再试');
    }
    instance.dialogVisible = true;
    instance.queryParams = op.queryParams;
    instance.handlerFunc = op.handlerFunc;
    instance.clickVisible();
    document.body.appendChild(instance.$el);
    document.body.style.overflow = 'hidden';
    console.log('newLoading', op);
    return instance;
  },

  isShow() {
    return instance.dialogVisible;
  },

  hide() {
    instance.dialogVisible = false;
    document.body.style.overflow = '';
  },

  abortUpload(succ_cb) {
    instance.abortUpload(() => {
      this.hide();
      succ_cb && succ_cb();
    });
  }


};

const install = () => {
  if (!Vue.$comBatchUploadDialog) {
    Vue.$comBatchUploadDialog = newLoading;
  }
  Vue.mixin({
    created() {
      this.$comBatchUploadDialog = Vue.$comBatchUploadDialog;
    }
  });
};

export default install;
